const division = {
    getlist: 'division/getlist',
    add: 'division/add',
    update: 'division/update',
    remove: 'division/remove',
    get: 'division/get',
    getall: 'division/getall',
}
export default division
